export default __webpack_public_path__ + "static/media/Mortgagewebservicesbg.936544a3.svg";